import {IWithSummaryModel} from "../../../../common/permission/api/entity/iWithSummary.model";
import {InsoleMaterialSummaryModel} from "./insoleMaterialSummary.model";

export class InsoleMaterialModel implements IWithSummaryModel<InsoleMaterialSummaryModel>{
    summary: InsoleMaterialSummaryModel;
    parent: InsoleMaterialSummaryModel;
}